import React, { useRef, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';

interface CSVDragDropUploadProps {
  onFileParsed: (file: File) => void;
}

const CSVDragDropUpload: React.FC<CSVDragDropUploadProps> = ({
  onFileParsed
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onFileParsed(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };

  return (
    <Box
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      sx={(theme) => ({
        border: isDragging
          ? `2px dashed ${theme.customColors.themePrimary}`
          : `2px dashed ${theme.customColors.themeNeutralPrimaryColor}`,
        borderRadius: '8px',
        padding: '30px',
        textAlign: 'center',
        transition: 'border 0.2s ease-in-out',
        mb: 2
      })}
    >
      <Typography variant="h6" gutterBottom>
        Drag & drop CSV file
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        or
      </Typography>
      <Button
        variant="contained"
        component="label"
        sx={(theme) => ({
          color: theme.customColors.themeSecondary,
          backgroundColor: theme.customColors.themePrimary,
          textTransform: 'capitalize',
          borderRadius: '8px',
          boxShadow: 'none',
          padding: '5px 10px'
        })}
      >
        Browse file
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          onChange={(e) => {
            if (e.target.files?.[0]) {
              onFileParsed(e.target.files[0]);
            }
          }}
          style={{ display: 'none' }}
        />
      </Button>
    </Box>
  );
};

export default CSVDragDropUpload;
